module.exports = __webpack_public_path__ + "img/comecando-a-acumular.svg";